// estandar de mensages en snackbar
export const alertMessage = {
  successUpdate: 'Actualización satisfactoria.',
  successDelete: 'Se eliminó satisfactoriamente.',
  successSave: 'Registro satisfactorio.',
  successPrint: 'Impresión satisfactoria',
  successConfiguration: 'Configuración satisfactoria.',
  formRequired: 'Falta completar  y/o corregir los campos obligatorios con caracteres validos.',
  levelsRequired: 'Debe asignar al menos un producto o categoría.',
  optionWithoutData: 'Aún no existe información registrada.',
  editDispatchDisabled: 'Despacho no disponible para edición.',
  extraFormRequired: 'Debe completar el formulario de Datos de Entidad',
  coordinatesValidate: 'Indicar las coordenadas en el mapa',
  entityCodeExists: 'El código de entidad ya existe',
  frequencyRequired: 'Se debe seleccionar como mínimo un día para la frecuencia de picking'
};
